export const SOLVVY_ADD_REMOVE_ITEM = '92ded037-580d-403e-ae59-26ca966a2108'
export const SOLVVY_RETURN_ITEM = 'b356b89b-8286-4fa6-a2ea-2bf16017f34a'
export const SOLVVY_REQUEST_EXTENSION = 'b1e9fe79-dc53-4d50-ae16-1df090a60a1a'
